import React from 'react';
import clsx from 'clsx';
import { ClassroomGroup } from '../boutique-classroom.types';
import { GROUP_CARD_VISIBLE_AVATARS } from '../boutique-classroom.constants';
import AvatarStack from './AvatarStack';

interface GroupCardProps {
	group: ClassroomGroup;
	isActive: boolean;
	onSelect: (groupId: number) => void;
}

export const GroupCard: React.FC<GroupCardProps> = ({ group, isActive, onSelect }) => {
	return (
		<button
			type="button"
			className={clsx('group-card', { 'group-card--active': isActive })}
			onClick={() => onSelect(group.id)}>
			<div className="group-card__header">
				<span
					className="group-card__name"
					title={group.name}>
					{group.name}
				</span>
			</div>
			<AvatarStack
				students={group.students}
				maxVisible={GROUP_CARD_VISIBLE_AVATARS}
				size="small"
			/>
		</button>
	);
};

export default GroupCard;
